module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dark"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-left center"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('router-link', {
    attrs: {
      "to": "/letter-form-anatomy"
    }
  }, [_vm._v("▲"), _c('br'), _vm._v("Letter-form Anatomy")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-right center"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('router-link', {
    attrs: {
      "to": "/italics-dashes"
    }
  }, [_vm._v("Italics, -, –, —, and  ˜"), _c('br'), _vm._v("▼")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content--first green clear"
  }, [_c('div', {
    staticClass: "column--single img--100"
  }, [_c('div', {
    staticClass: "column--single"
  }, [_vm._l((_vm.categories), function(category, idx) {
    return _c('type-category', {
      key: category.id,
      attrs: {
        "category": category,
        "isLast": idx === _vm.categories.length - 1
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--small clear"
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--medium center"
  }, [_c('router-link', {
    staticClass: "button caps",
    attrs: {
      "to": "/italics-dashes"
    }
  }, [_vm._v("Next Chapter")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap clear"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-section-title caps rotate"
  }, [_vm._v("\n          The Basics\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-section-number"
  }, [_vm._v("1–4")]), _vm._v(" "), _c('h1', [_vm._v("Type Categories")]), _vm._v(" "), _c('p', {
    staticClass: "header-section-desc"
  }, [_vm._v("Compare Korean and English stroke variations to pair up similar type categories.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3889542d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TypeCategories.vue
// module id = 139
// module chunks = 0